__turbopack_context__.v({
  "badge": "B1PcYa_badge",
  "shimmer": "B1PcYa_shimmer",
  "text-bar-sweep": "B1PcYa_text-bar-sweep",
});
